import { Component, OnInit, HostListener } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { RoutingService } from '../../services/routing.service';
import { RestapiService } from '../../services/restapi.service';
import { Subscription } from 'rxjs';
import { SeoService } from 'src/app/services/seo.service';
@Component({
  selector: 'app-calendario',
  templateUrl: './calendario.component.html',
  styleUrls: ['./calendario.component.scss']
})


export class CalendarioComponent implements OnInit {
  context: any;
  schedule: any;
  lastPage: number = 0;
  page: number = 0;

  cea: any = "";
  cont: any ;
  social: any ;

  public search: string = '';
  months: any = [
    { value: '01', label: 'Enero', },
    { value: '02', label: 'Febrero', },
    { value: '03', label: 'Marzo', },
    { value: '04', label: 'Abril', },
    { value: '05', label: 'Mayo', },
    { value: '06', label: 'Junio', },
    { value: '07', label: 'Julio', },
    { value: '08', label: 'Agosto', },
    { value: '09', label: 'Septiembre', },
    { value: '10', label: 'Octubre', },
    { value: '11', label: 'Noviembre', },
    { value: '12', label: 'Diciembre', },
  ];

  private routeObs: Subscription;
  constructor(
    private activatedRoute: ActivatedRoute,
    public route: RoutingService,
    public api: RestapiService,
    public seo: SeoService
  ) {
    this.routeObs = this.route.onRouteChange.subscribe(res => {
      console.log('routeObs change')
      setTimeout(() => {
        this.route.setCurrent(window.location.pathname);
        delete this.schedule;
        delete this.cont;
        delete this.social;
        this.page = 0;
        this.lastPage = 0;
        this.cea = this.activatedRoute.snapshot.paramMap.get('context');
        this.loadContent();
      }, 10);
    });

  }

  ngOnInit(): void {
    this.cea = this.activatedRoute.snapshot.paramMap.get('context');

    this.schedule = [];
    this.loadContent();

  }

  pickSea(value) {
    this.cea = value;
    /* this.page=0;
    this.loadContent(); */
    this.route.goTo('calendario/' + value)

  }

  loadContent() {
    this.page++;
    this.page === 1 ? this.schedule = [] : '';
    this.api.getdata('webschedule', {
      page: this.page,
      filters: { websection_id: { value: this.cea != 'todos' ? this.cea : '' } },
      per_page: 10
    }).subscribe(res => {
      if (res.status == true) {
        console.log('WEBSCHEDULE', res);
        this.lastPage = res.result.last_page;
        if (res.result.data.length > 0) {
          res.result.data.forEach(el => {
            this.schedule.push(el);
          });
        }
        if(this.cea != 'todos'){
          this.cont = res.result.data[0].websection;
          this.social = {};
          this.cont.websectionosocial.forEach(el => {
            this.social[el.name] = el.link;
          });
        }
        this.seo.generateTags({
          title:'WWF Educación Ambiental, Calendario de actividades',
          description: 'Calendario de actividades',
          image: '/assets/brand.png',
          slug: window.location.href,
        });
      }
    })
  }

  onScroll() {
    if (this.page < this.lastPage) {
      this.loadContent();
    } else {
      console.log('No more lines. Finish page!');
    }
  }

  filterFaq(item) {
    if (this.search === '' || !this.search || item.title.toLowerCase().indexOf(this.search) > -1) {
      return false;
    }
    else {
      return true;
    }
  }
}
